interface PlayerInfoProps {
  firstName: string;
  lastName: string;
  subbedPlayer: string | null;
}

export const PlayerInfo = ({ firstName, lastName, subbedPlayer }: PlayerInfoProps) => (
  <div className='flex items-center'>
    <span className='line-clamp-3 text-sm font-medium text-gray-900'>
      {`${subbedPlayer === null ? `${firstName} ${lastName}` : 'SUB for ' + subbedPlayer}`}
    </span>
  </div>
);
